module.exports = __webpack_public_path__ + "static/Cocktail_Bites-d469c281ea0145fd02b29649e007f16e.png";